import React from 'react';

import downloadIcon from 'images/icons/invite/download.svg';
import payIcon from 'images/icons/invite/cash.svg';

import Tooltip from 'components/ui/Tooltip';
import { useContext } from '../Context';

export default function Actions({ row }) {
  const { dispatch, actions, state } = useContext();

  const payInvoice = (e) => {
    swal(
      {
        title: '',
        text: 'Would you like to mark this payment paid?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

          actions.pay(dispatch, row.id);
        }
      },
    );
  };

  return (
    <>
      <div>
        {row.attributes.status == 'open' && (
          <a
            data-tip="Mark as Paid"
            onClick={payInvoice}
            className="mr5"
            target="_blank"
          >
            <img src={payIcon} />
          </a>
        )}

        <a
          data-tip="Download"
          href={row.attributes.report}
          target="_blank"
          rel="noreferrer"
        >
          <img src={downloadIcon} />
        </a>
      </div>
      <Tooltip />
    </>
  );
}
